import React, { useEffect } from "react";
import CoursesReferral from "./CoursesRefrral";
import OverviewCards from "./OverviewCards";
import { useDispatch, useSelector } from "react-redux";
import { fetchpartnerbyId } from "../../redux/slices/partnerSlice";
import LeadForm from "../../component/Minicrm/PunchLead";

const PartnerHome = () => {
  const partners = useSelector((state) => state?.partner);
  const partner = partners?.fetchById;
  console.log(partner);
  const dispatch = useDispatch();
  const partnerId = JSON.parse(sessionStorage.getItem("user"));
  console.log(partnerId);
  useEffect(() => {
    // fetch partner by id
    dispatch(fetchpartnerbyId(partnerId?.userId));
  }, []);
  return (
    <div>
      <OverviewCards partner={partner} />
      <CoursesReferral partner={partner} />
      <LeadForm />
    </div>
  );
};

export default PartnerHome;
